'use client'

import { createContext, useContext, useEffect } from 'react'
import type { SiteSettings } from '@/lib/settings'

const SettingsContext = createContext<SiteSettings | null>(null)

export function useSettings() {
  const context = useContext(SettingsContext)
  if (!context) {
    throw new Error('useSettings must be used within a BrandingProvider')
  }
  return context
}

export function BrandingProvider({
  settings,
  children,
}: {
  settings: SiteSettings
  children: React.ReactNode
}) {
  useEffect(() => {
    if (settings?.branding?.primaryColor) {
      document.documentElement.style.setProperty('--primary', settings.branding.primaryColor)
    }
  }, [settings])

  return (
    <SettingsContext.Provider value={settings}>
      {children}
    </SettingsContext.Provider>
  )
}